import { createContext, useContext } from 'react'
import { V4_ENABLED } from 'views/TradingCompetitionV4/config'
import { V3_ADDRESS, V3_API_URL, V3_CHAIN_ID } from './config'
import { COMPETITIONS, CREATE, REFERRAL } from './routes'

/**
 * Which competition contract the list and detail pages read. Default = V3; the V4 pages wrap the same views in a
 * provider with the V4 address, API and link base, so one UI serves both contracts during the overlap.
 */
export type ContractBinding = { version: 3 | 4; address: `0x${string}` | ''; chainId: number; apiUrl: string; base: string; tabs: { href: string; label: string }[] }
export const V3_BINDING: ContractBinding = {
  version: 3, address: V3_ADDRESS, chainId: V3_CHAIN_ID, apiUrl: V3_API_URL, base: V4_ENABLED ? '/trading-competition/legacy' : '/trading-competition-v3',
  tabs: [
    { href: COMPETITIONS, label: 'Competitions' },
    { href: CREATE, label: 'Create' },
    { href: REFERRAL, label: 'Rewards & referral' },
  ],
}
export const ContractContext = createContext<ContractBinding>(V3_BINDING)
export const useContractBinding = () => useContext(ContractContext)
